import { Locale, type LocalizedString } from "../Locale.js";
import type { Tenant } from "../Tenant.js";
import { getPathInLocale } from "./getPathInLocale.js";

export function getWebsiteAuditPath(tenant: Tenant): string {
	const pathMap: LocalizedString = {
		[Locale.cs]: "/reseni/audit-a-optimalizace-webu",
		[Locale.en]: "/solutions/website-audit",
	};

	return getPathInLocale(tenant.locale, pathMap);
}
